<template>
	<v-select
			class="rounded-lg required"
			hide-details="auto"
			label="Place"
			:items="venues"
			item-text="name"
			item-value="id"
			outlined
			:rules="rules"
			:value="value"
			@input="v => $emit('input', v)"
	>
		<template v-slot:selection="{ item, props }">
			<div v-bind="props" class="my-2">
				<div>{{ item.name }}</div>
				<template v-if="item?.overwrittenNames?.length > 0">
					<div
						v-for="(overwrittenName) in item.overwrittenNames"
						:key="`overwritten-name-${overwrittenName}`"
						class="body-2 font-italic text--secondary"
					>
						{{ overwrittenName }}
					</div>
				</template>
			</div>
		</template>
		<template v-slot:item="{ item, props }">
			<div v-bind="props">
				<div>{{ item.name }}</div>
				<template v-if="item?.overwrittenNames?.length > 0">
					<div
						v-for="(overwrittenName) in item.overwrittenNames"
						:key="`overwritten-name-${overwrittenName}`"
						class="body-2 font-italic text--secondary"
					>
						{{ overwrittenName }}
					</div>
				</template>
			</div>
		</template>
	</v-select>
</template>

<script>
export default {
	name: 'VenueSelect',
	props: {
		rules: {
			type: Array,
			default: () => []
		},
		value: {
			type: [String, Number],
			default: ''
		},
		venues: {
			type: Array,
			default: () => []
		}
	}
}
</script>
